// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Color = require("../Chip.Model.Color/index.js");
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Chip_Model_Enemy = require("../Chip.Model.Enemy/index.js");
var Chip_Model_Item = require("../Chip.Model.Item/index.js");
var Chip_Model_SwitchState = require("../Chip.Model.SwitchState/index.js");
var Chip_Model_WallType = require("../Chip.Model.WallType/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Show = require("../Data.Show/index.js");
var Wall = (function () {
    function Wall(value0) {
        this.value0 = value0;
    };
    Wall.create = function (value0) {
        return new Wall(value0);
    };
    return Wall;
})();
var Door = (function () {
    function Door(value0) {
        this.value0 = value0;
    };
    Door.create = function (value0) {
        return new Door(value0);
    };
    return Door;
})();
var Chip = (function () {
    function Chip() {

    };
    Chip.value = new Chip();
    return Chip;
})();
var Socket = (function () {
    function Socket() {

    };
    Socket.value = new Socket();
    return Socket;
})();
var Exit = (function () {
    function Exit() {

    };
    Exit.value = new Exit();
    return Exit;
})();
var Hint = (function () {
    function Hint() {

    };
    Hint.value = new Hint();
    return Hint;
})();
var Water = (function () {
    function Water() {

    };
    Water.value = new Water();
    return Water;
})();
var Dirt = (function () {
    function Dirt() {

    };
    Dirt.value = new Dirt();
    return Dirt;
})();
var Gravel = (function () {
    function Gravel() {

    };
    Gravel.value = new Gravel();
    return Gravel;
})();
var Fire = (function () {
    function Fire() {

    };
    Fire.value = new Fire();
    return Fire;
})();
var Item = (function () {
    function Item(value0) {
        this.value0 = value0;
    };
    Item.create = function (value0) {
        return new Item(value0);
    };
    return Item;
})();
var Force = (function () {
    function Force(value0) {
        this.value0 = value0;
    };
    Force.create = function (value0) {
        return new Force(value0);
    };
    return Force;
})();
var Ice = (function () {
    function Ice() {

    };
    Ice.value = new Ice();
    return Ice;
})();
var IceCorner = (function () {
    function IceCorner(value0) {
        this.value0 = value0;
    };
    IceCorner.create = function (value0) {
        return new IceCorner(value0);
    };
    return IceCorner;
})();
var SwitchableWall = (function () {
    function SwitchableWall(value0) {
        this.value0 = value0;
    };
    SwitchableWall.create = function (value0) {
        return new SwitchableWall(value0);
    };
    return SwitchableWall;
})();
var WallButton = (function () {
    function WallButton() {

    };
    WallButton.value = new WallButton();
    return WallButton;
})();
var TankButton = (function () {
    function TankButton() {

    };
    TankButton.value = new TankButton();
    return TankButton;
})();
var Bomb = (function () {
    function Bomb() {

    };
    Bomb.value = new Bomb();
    return Bomb;
})();
var CloneMachine = (function () {
    function CloneMachine(value0) {
        this.value0 = value0;
    };
    CloneMachine.create = function (value0) {
        return new CloneMachine(value0);
    };
    return CloneMachine;
})();
var CloneMachineButton = (function () {
    function CloneMachineButton() {

    };
    CloneMachineButton.value = new CloneMachineButton();
    return CloneMachineButton;
})();
var Trap = (function () {
    function Trap() {

    };
    Trap.value = new Trap();
    return Trap;
})();
var TrapButton = (function () {
    function TrapButton() {

    };
    TrapButton.value = new TrapButton();
    return TrapButton;
})();
var Thief = (function () {
    function Thief() {

    };
    Thief.value = new Thief();
    return Thief;
})();
var Teleport = (function () {
    function Teleport() {

    };
    Teleport.value = new Teleport();
    return Teleport;
})();
var showTile = new Data_Show.Show(function (v) {
    if (v instanceof Wall) {
        return Data_Show.show(Chip_Model_WallType.showWallType)(v.value0);
    };
    if (v instanceof Door) {
        if (v.value0 instanceof Chip_Model_Color.Red) {
            return "R";
        };
        if (v.value0 instanceof Chip_Model_Color.Cyan) {
            return "C";
        };
        if (v.value0 instanceof Chip_Model_Color.Yellow) {
            return "Y";
        };
        if (v.value0 instanceof Chip_Model_Color.Green) {
            return "G";
        };
        throw new Error("Failed pattern match at Chip.Model.Tile (line 46, column 19 - line 50, column 19): " + [ v.value0.constructor.name ]);
    };
    if (v instanceof Chip) {
        return "+";
    };
    if (v instanceof Socket) {
        return "-";
    };
    if (v instanceof Exit) {
        return "<";
    };
    if (v instanceof Hint) {
        return "?";
    };
    if (v instanceof Water) {
        return "~";
    };
    if (v instanceof Dirt) {
        return "\u2248";
    };
    if (v instanceof Fire) {
        return "^";
    };
    if (v instanceof Item) {
        return Data_Show.show(Chip_Model_Item.showItem)(v.value0);
    };
    if (v instanceof Force) {
        if (v.value0 instanceof Chip_Model_Direction.Down) {
            return "\u2193";
        };
        if (v.value0 instanceof Chip_Model_Direction.Left) {
            return "\u2190";
        };
        if (v.value0 instanceof Chip_Model_Direction.Up) {
            return "\u2191";
        };
        if (v.value0 instanceof Chip_Model_Direction.Right) {
            return "\u2192";
        };
        throw new Error("Failed pattern match at Chip.Model.Tile (line 59, column 24 - line 63, column 19): " + [ v.value0.constructor.name ]);
    };
    if (v instanceof Ice) {
        return "\u256c";
    };
    if (v instanceof IceCorner) {
        if (v.value0 instanceof Chip_Model_Direction.Down) {
            return "\u255d";
        };
        if (v.value0 instanceof Chip_Model_Direction.Left) {
            return "\u255a";
        };
        if (v.value0 instanceof Chip_Model_Direction.Up) {
            return "\u2554";
        };
        if (v.value0 instanceof Chip_Model_Direction.Right) {
            return "\u2557";
        };
        throw new Error("Failed pattern match at Chip.Model.Tile (line 65, column 28 - line 69, column 19): " + [ v.value0.constructor.name ]);
    };
    if (v instanceof SwitchableWall && v.value0 instanceof Chip_Model_SwitchState.On) {
        return "[";
    };
    if (v instanceof SwitchableWall && v.value0 instanceof Chip_Model_SwitchState.Off) {
        return "]";
    };
    if (v instanceof WallButton) {
        return ".";
    };
    if (v instanceof TankButton) {
        return ",";
    };
    if (v instanceof Bomb) {
        return "*";
    };
    if (v instanceof CloneMachine) {
        return "<-." + Data_Show.show(Chip_Model_Enemy.showEnemy)(v.value0);
    };
    if (v instanceof CloneMachineButton) {
        return "\u21ba";
    };
    if (v instanceof Trap) {
        return ";";
    };
    if (v instanceof TrapButton) {
        return ":";
    };
    if (v instanceof Thief) {
        return "t";
    };
    if (v instanceof Teleport) {
        return "o";
    };
    if (v instanceof Gravel) {
        return "\u2591";
    };
    throw new Error("Failed pattern match at Chip.Model.Tile (line 44, column 10 - line 81, column 18): " + [ v.constructor.name ]);
});
var eqTile = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Wall && y instanceof Wall) {
            return Data_Eq.eq(Chip_Model_WallType.eqWallType)(x.value0)(y.value0);
        };
        if (x instanceof Door && y instanceof Door) {
            return Data_Eq.eq(Chip_Model_Color.eqColor)(x.value0)(y.value0);
        };
        if (x instanceof Chip && y instanceof Chip) {
            return true;
        };
        if (x instanceof Socket && y instanceof Socket) {
            return true;
        };
        if (x instanceof Exit && y instanceof Exit) {
            return true;
        };
        if (x instanceof Hint && y instanceof Hint) {
            return true;
        };
        if (x instanceof Water && y instanceof Water) {
            return true;
        };
        if (x instanceof Dirt && y instanceof Dirt) {
            return true;
        };
        if (x instanceof Gravel && y instanceof Gravel) {
            return true;
        };
        if (x instanceof Fire && y instanceof Fire) {
            return true;
        };
        if (x instanceof Item && y instanceof Item) {
            return Data_Eq.eq(Chip_Model_Item.eqItem)(x.value0)(y.value0);
        };
        if (x instanceof Force && y instanceof Force) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        if (x instanceof Ice && y instanceof Ice) {
            return true;
        };
        if (x instanceof IceCorner && y instanceof IceCorner) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        if (x instanceof SwitchableWall && y instanceof SwitchableWall) {
            return Data_Eq.eq(Chip_Model_SwitchState.eqSwitchState)(x.value0)(y.value0);
        };
        if (x instanceof WallButton && y instanceof WallButton) {
            return true;
        };
        if (x instanceof TankButton && y instanceof TankButton) {
            return true;
        };
        if (x instanceof Bomb && y instanceof Bomb) {
            return true;
        };
        if (x instanceof CloneMachine && y instanceof CloneMachine) {
            return Data_Eq.eq(Chip_Model_Enemy.eqEnemy)(x.value0)(y.value0);
        };
        if (x instanceof CloneMachineButton && y instanceof CloneMachineButton) {
            return true;
        };
        if (x instanceof Trap && y instanceof Trap) {
            return true;
        };
        if (x instanceof TrapButton && y instanceof TrapButton) {
            return true;
        };
        if (x instanceof Thief && y instanceof Thief) {
            return true;
        };
        if (x instanceof Teleport && y instanceof Teleport) {
            return true;
        };
        return false;
    };
});
module.exports = {
    Wall: Wall,
    Door: Door,
    Chip: Chip,
    Socket: Socket,
    Exit: Exit,
    Hint: Hint,
    Water: Water,
    Dirt: Dirt,
    Gravel: Gravel,
    Fire: Fire,
    Item: Item,
    Force: Force,
    Ice: Ice,
    IceCorner: IceCorner,
    SwitchableWall: SwitchableWall,
    WallButton: WallButton,
    TankButton: TankButton,
    Bomb: Bomb,
    CloneMachine: CloneMachine,
    CloneMachineButton: CloneMachineButton,
    Trap: Trap,
    TrapButton: TrapButton,
    Thief: Thief,
    Teleport: Teleport,
    eqTile: eqTile,
    showTile: showTile
};
